import { v4 } from 'uuid';

import { UploadedFile } from '../useUserUpload/use-user-upload.types';

interface FileTypeConfig {
  mimeType: string;
  icon: string;
}

const docTypes: Record<string, FileTypeConfig> = {
  '.pdf': {
    mimeType: 'application/pdf',
    icon: '/app/static/images/icons/pdf.svg',
  },
  '.txt': {
    mimeType: 'text/plain',
    icon: '/app/static/images/icons/txt.svg',
  },
  '.csv': {
    mimeType: 'text/csv',
    icon: '/app/static/images/icons/csv.svg',
  },
};

export const imageTypes: Record<string, FileTypeConfig> = {
  '.png': { mimeType: 'image/png', icon: '/app/static/images/icons/png.svg' },
  '.jpeg': { mimeType: 'image/jpeg', icon: '/app/static/images/icons/jpg.svg' },
  '.jpg': { mimeType: 'image/jpeg', icon: '/app/static/images/icons/jpg.svg' },
};

export const allowedFileTypes: Record<string, FileTypeConfig> = {
  ...docTypes,
  ...imageTypes,
};

export const allowedTypesMimeType: string[] = [
  ...new Set(Object.values(allowedFileTypes).map(f => f.mimeType)),
];

export const allowedTypesExtension = Object.keys(allowedFileTypes).join(',');

export const formatUploadFiles = (files: File[]): UploadedFile[] => {
  const selectedFiles = Array.from(files);

  return selectedFiles.map(i => {
    const thumbnailUrl = i.type.startsWith('image/')
      ? URL.createObjectURL(i)
      : undefined;

    return {
      field_name: v4(),
      fileType: i.type,
      status: 'uploading',
      fileData: i,
      name: i.name,
      sizeInBytes: i.size,
      thumbnailUrl,
    };
  });
};
